export default __webpack_public_path__ + "static/media/checkbox.24a58c0c.svg";